import { Link } from "react-router-dom";
import {
  faArrowRight,
  faBath,
  faBed,
  faLocationDot,
  faRulerCombined,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ListingCard({ property, image }) {
  const isResidential =
    property.PropertyType?.toLowerCase().includes("residential");

  return (
    <Link
      to={`/listing/${property.ListingKey}`}
      className="group block"
    >
      <div className="overflow-hidden rounded-lg bg-white/70 shadow-xl transition-all duration-500">

        <div className="relative h-[320px] overflow-hidden">
          <img
            // src={image?.MediaURL ?? "/placeholder.jpg"}
            src={image}
            alt={property.UnparsedAddress ?? "Property"}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
          />

          {/* Price Badge */}
          <div className="w-full absolute top-0 flex flex-col lg:flex-row justify-between lg:items-center gap-3 p-3">
            <div className="rounded-full bg-cottage-accent px-5 py-2 text-lg font-semibold text-white shadow-lg w-fit">
              ${property.ListPrice?.toLocaleString()}
            </div>

            {/* Property Type */}
            <div className="rounded-full bg-black/40 px-4 py-2 text-sm uppercase tracking-wider text-white backdrop-blur-md w-fit">
              {property.PropertyType}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-5">
          {/* Location */}
          <p className="mb-3 flex items-center text-sm uppercase tracking-[0.3em] text-cottage-primary">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="mr-2"
            />
            {property.City ?? property.CityRegion ?? property.CrossStreet}
          </p>

          {/* Address */}
          <h3 className="text-xl font-light leading-tight">
            {property.StreetNumber} {property.StreetName} {property.StreetSuffix}
          </h3>

          {/* Divider */}
          <div className="my-5 h-px bg-gray-300" />

          {/* Features */}
          <div className="flex flex-col lg:flex-row gap-3 lg:items-center justify-between">
            <div className="flex gap-6 text-cottage-primary">
              {property.PropertyType !== "Commercial" && (
                <>
                  <div className="flex items-center gap-2">
                    <FontAwesomeIcon
                      icon={faBed}
                      className="text-cottage-accent"
                    />
                    <span>
                      {property.BedroomsTotal || property.BedroomsTotalInteger}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <FontAwesomeIcon
                      icon={faBath}
                      className="text-cottage-accent"
                    />
                    <span>
                      {property.BathroomsTotalInteger}
                    </span>
                  </div>
                </>
              )}

              <div className="flex items-center gap-2">
                <FontAwesomeIcon
                  icon={faRulerCombined}
                  className="text-cottage-accent"
                />
                <span>
                  {property.LivingAreaRange ?? "--"} sq.ft.
                </span>
              </div>
            </div>

            {/* CTA */}
            <div className=" py-2 px-4 bg-cottage-accent border rounded-lg border-transparent text-white w-fit group-hover:bg-cottage-primary">
              View
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
